<template>
  <div>
    <!-- class="settings-content" -->
    <div>
      <b-breadcrumb :items="navigationItems" />
      <loading-spinner v-show="loading" />
      <configuration-custom-id
        :enabled="shouldPromptForCustomId"
        @confirm="customIdProvided"
      />
      <b-container>
        <b-form v-show="!loading">
          <b-row align-v="center">
            <b-col
              cols="7"
              class="pl-0"
            >
              <h2> Edit configuration</h2>
            </b-col>
          </b-row>
          <b-row>
            <p class="mr-2">
              Updating configuration:
            </p><span> {{ applicableConfigurationId }}</span>
          </b-row>
          <b-row align-v="start">
            <b-col
              cols="1"
              class="mr-2"
            >
              <label for="config-Name">Name:</label>
            </b-col>
            <b-col cols="3">
              <b-form-input
                id="config-Name"
                v-model.trim="configuration.name"
                size="sm"
                type="text"
                :state="($v.configuration.name.$error) ? false: null"
              />
              <b-form-invalid-feedback id="config-name-invalid-feedback">
                Required and must be at least 3 characters
              </b-form-invalid-feedback>
            </b-col>
            <b-col
              cols="1"
              class="mr-2"
            >
              <label for="config-Description">Description:</label>
            </b-col>
            <b-col cols="6">
              <b-form-input
                id="config-Description"
                v-model.trim="configuration.description"
                size="sm"
                type="text"
                :state="($v.configuration.description.$error) ? false: null"
              />
              <b-form-invalid-feedback id="config-Description-invalid-feedback">
                Required and must be at least 3 characters
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col cols="2">
              <label for="config-source">Application Source:</label>
            </b-col>
            <b-col cols="5">
              <b-form-select
                id="config-source"
                v-model="configuration.selectedAppSource"
                :options="appSource"
                size="sm"
              />
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <h5>Product ID Alias</h5>
          </b-row>
          <b-row>
            <p class="mr-2">
              Used in processing to identify the product or magazine code.
            </p>
          </b-row>
          <b-row>
            <b-col
              cols="1"
              class="mr-2"
            >
              <label for="prodIdAlias">Alias:</label>
            </b-col>
            <b-col cols="2">
              <b-form-input
                id="prodIdAlias"
                v-model.trim="configuration.prodAliasId"
                size="sm"
                type="text"
              />
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <h5>Demo Site Payment Processing</h5>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-checkbox
                id="demo-in-production-checkbox"
                v-model="configuration.demoClient"
                plain
                class="ml-2"
              >
                Use this configuration for demo sites.
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row
            v-show="configuration.demoClient"
            cols="12"
          >
            <b-col cols="12">
              <span class="warning-message ml-4">Simulated payment processing enabled</span>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <h5>Select Service for Payment Processing</h5>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-form-radio-group
                id="payment-service-radio-group"
                v-model="configuration.selectedPaymentService"
                :options="paymentServices"
                plain
                name="payment-service-selection"
              />
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <h5>Credit Cards</h5>
            <b-col cols="12">
              <b-form-checkbox
                id="credit-cards-checkbox"
                v-model="configuration.credit"
                plain
                class="ml-2"
              >
                Accepted Credit Cards
              </b-form-checkbox>
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="ml-4 pl-2"
                :state="($v.configuration.selectedCardTypes.$error) ? false: null"
                invalid-feedback="Select at least one type of credit card"
              >
                <b-form-checkbox-group
                  v-model="configuration.selectedCardTypes"
                  :disabled="!configuration.credit"
                  plain
                  name="cardTypes"
                  :options="cardTypes"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox
                id="auth-checkbox"
                v-model="configuration.authCallEnabled"
                plain
                class="ml-2"
              >
                Perform real-time authorization / settlement
              </b-form-checkbox>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    class="ml-4 pl-2"
                    plain
                    :state="($v.configuration.selectedTransactionType.$error) ? false: null"
                    invalid-feedback="Select authorization type"
                  >
                    <b-form-radio-group
                      id="auth-radio"
                      v-model="configuration.selectedTransactionType"
                      plain
                      :options="authTypes"
                      :disabled="!configuration.authCallEnabled"
                      name="auth-selection"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox
                id="avs-checkbox"
                v-model="configuration.addressVerification"
                plain
                class="ml-2 mb-2"
              >
                Address Verification (AVS)
              </b-form-checkbox>
            </b-col>
            <b-col
              v-show="configuration.addressVerification"
              cols="12"
            >
              <b-col
                cols="12"
                class="ml-3 mb-1"
              >
                Accepted AVS codes:
              </b-col>
              <b-form-group
                class="ml-4 pl-2"
                :state="($v.configuration.addressVerificationCodes.$error) ? false : null"
                invalid-feedback="Enable at least one AVS code"
              >
                <b-col
                  v-for="avsOption in addressVerificationOptions"
                  v-show="configuration.addressVerification"
                  :key="avsOption.code"
                  cols="12"
                >
                  <b-form-checkbox
                    :key="avsOption.code"
                    v-model="configuration.addressVerificationCodes"
                    :value="avsOption.code"
                    plain
                    class="m1-2"
                  >
                    {{ avsOption.label }}
                  </b-form-checkbox>
                </b-col>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox
                id="expmonth-checkbox"
                v-model="configuration.currentMonthExpiration"
                plain
                class="ml-2 mb-2"
              >
                Accept credit cards having current month and year as expiration date
              </b-form-checkbox>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox
                id="cvv-checkbox"
                v-model="configuration.cvv"
                plain
                class="ml-2"
              >
                Require CVV
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="center">
            <h5>Support Wrapper</h5>
            <b-col cols="12">
              <b-form-checkbox
                id="cds-wallet-checkbox"
                v-model="configuration.supportWrapper"
                plain
                class="ml-2 mb-2"
              >
                Enable Wrapper Support
              </b-form-checkbox>
            </b-col>
            <b-col
              v-show="configuration.supportWrapper"
              cols="12"
            >
              <b-row>
                <b-col
                  cols="2"
                  align="right"
                >
                  <label for="hostedURL">Hosted URL:</label>
                </b-col>
                <b-col cols="7">
                  <b-form-input
                    id="hostedURL"
                    v-model.trim="configuration.hostedUrl"
                    size="sm"
                    type="text"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="center">
            <h5>CDS Wallet</h5>
            <b-col cols="12">
              <b-form-checkbox
                id="cds-wallet-checkbox"
                v-model="configuration.cdsGlobalWallet"
                plain
                class="ml-2 mb-2"
              >
                Wallet as payment option
              </b-form-checkbox>
            </b-col>
            <b-col
              v-show="configuration.cdsGlobalWallet"
              cols="12"
            >
              <b-row>
                <b-col
                  cols="2"
                  align="right"
                >
                  <label for="cdsGlobalWalletCallbackUrl">Auth Callback URL:</label>
                </b-col>
                <b-col cols="7">
                  <b-form-input
                    id="cdsGlobalWalletCallbackUrl"
                    v-model.trim="configuration.cdsGlobalWalletCallbackUrl"
                    size="sm"
                    type="text"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <h4>Alternate Payments</h4>
          </b-row>
          <b-row align-v="start">
            <b-col cols="12">
              <b-form-checkbox
                id="amazon-pay-checkbox"
                v-model="configuration.amazonPay"
                plain
                class="m1-2"
              >
                <h5>Enable Amazon Pay</h5>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row
            v-show="configuration.amazonPay"
            align-v="start"
          >
            <b-col cols="12">
              <b-tabs content-class="mt-3">
                <b-tab title="Choose Existing Payment Details">
                  <b-form-group
                    v-show="showAmazonPaySelect"
                    label-for="amazon-pay-select"
                    invalid-feedback="A configuration for Amazon Pay is required."
                  >
                    <b-form-select
                      id="amazon-pay-select"
                      v-model="configuration.amazonPayConfigurationId"
                      :options="amazonPayOptions"
                    />
                  </b-form-group>
                  <b-button
                    v-show="showAmazonPaySelect"
                    variant="primary"
                    class="ml-3"
                    @click="editPayment('AMAZON', configuration.amazonPayConfigurationId)"
                  >
                    Edit Publisher Payment Details
                  </b-button>
                  <div v-show="!showAmazonPaySelect">
                    No Amazon Pay configurations available, please
                    <router-link
                      class="navigation-links"
                      disabled="true"
                      :to="{name: 'alternativePayments', params: { clientId: clientId }}"
                    >
                      create one
                    </router-link>
                    .
                  </div>
                </b-tab>
                <b-tab title="Enter Payment Details">
                  <edit-alternative-payment-item
                    :payment-type="'AMAZON'"
                    :configuration-id="configurationId"
                  />
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <b-col cols="12">
              <b-form-checkbox
                id="apple-pay-checkbox"
                v-model="configuration.applePay"
                plain
                class="m1-2"
              >
                <h5>Enable Apple Pay</h5>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row
            v-show="configuration.applePay"
            align-v="start"
          >
            <b-col cols="12">
              <b-tabs content-class="mt-3">
                <b-tab title="Choose Existing Payment Details">
                  <b-form-group
                    v-show="showApplePaySelect"
                    label-for="apple-pay-select"
                    invalid-feedback="A configuration for Apple Pay is required."
                  >
                    <b-form-select
                      id="apple-pay-select"
                      v-model="configuration.applePayConfigurationId"
                      :options="applePayOptions"
                    />
                  </b-form-group>
                  <b-button
                    v-show="showApplePaySelect"
                    variant="primary"
                    class="ml-3"
                    @click="editPayment('APPLE', configuration.applePayConfigurationId)"
                  >
                    Edit Publisher Payment Details
                  </b-button>
                  <div v-show="!showApplePaySelect">
                    No Apple Pay configurations availabae, please
                    <router-link
                      class="navigation-links"
                      disabled="true"
                      :to="{name: 'alternativePayments', params: { clientId: clientId }}"
                    >
                      create one
                    </router-link>
                    .
                  </div>
                </b-tab>
                <b-tab title="Enter Payment Details">
                  <edit-alternative-payment-item
                    :payment-type="'APPLE'"
                    :configuration-id="configurationId"
                    :alternative-payment.sync="configuration.applePayConfiguration"
                  />
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <b-col cols="12">
              <b-form-checkbox
                id="pay-pal-checkbox"
                v-model="configuration.payPal"
                plain
                class="m1-2"
              >
                <h5>Enable PayPal</h5>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row
            v-show="configuration.payPal"
            align-v="start"
          >
            <b-col cols="12">
              <b-tabs content-class="mt-3">
                <b-tab title="Choose Existing Payment Details">
                  <b-form-group
                    v-show="showPayPalSelect"
                    label-for="pay-pal-select"
                    invalid-feedback="A configuration for PayPal is required."
                  >
                    <b-form-select
                      id="payment-type-select"
                      v-model="configuration.payPalConfigurationId"
                      :options="payPalOptions"
                    />
                  </b-form-group>
                  <div v-show="!showPayPalSelect">
                    No PayPal configurations available, please
                    <router-link
                      class="navigation-links"
                      disabled="true"
                      :to="{name: 'alternativePayments', params: { clientId: clientId }}"
                    >
                      create one
                    </router-link>
                    .
                  </div>
                </b-tab>
                <b-tab title="Enter Payment Details">
                  <edit-alternative-payment-item
                    :payment-type="'PAYPAL'"
                    :configuration-id="configurationId"
                    :load-payment="!hasOwnPayPalDetails"
                  />
                </b-tab>
              </b-tabs>
            </b-col>
            <b-col cols="12">
              <b-button
                v-show="showPayPalSelect"
                variant="primary"
                class="ml-3"
                @click="editPayment('PAYPAL', configuration.payPalConfigurationId)"
              >
                Edit Publisher Payment Details
              </b-button>
            </b-col>
          </b-row>
          <br>
          <b-row
            v-show="tokenizationForAltPayments"
            align-v="center"
          >
            <b-col cols="5">
              <h5>Alternative Payments Tokenization</h5>
              <b-form-group
                class="ml-4 pl-2"
                plain
                :state="
                  $v.configuration.selectedTokenizationStage.$error
                    ? false
                    : null
                "
                invalid-feedback="Select tokenize stage"
              >
                <b-form-radio-group
                  id="tokenize-radio"
                  v-model="configuration.selectedTokenizationStage"
                  plain
                  :options="tokenizeStages"
                  name="tokenize-selection"
                />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <h5>Alternative Payments Buttons Size</h5>
              <b-form-select
                v-model="configuration.selectedButtonsSize"
                :options="buttonsSizes"
                size="sm"
                class="ml-4 pl-2"
              />
            </b-col>
            <b-col cols="2" />
          </b-row>
          <b-row align-v="center">
            <h5>reCAPTCHA</h5>
            <b-col cols="12">
              <b-form-checkbox
                id="recaptcha-checkbox"
                v-model="configuration.recaptcha"
                plain
                class="ml-2 mb-2"
              >
                Enable reCAPTCHA
              </b-form-checkbox>
            </b-col>
            <b-col
              v-show="configuration.recaptcha"
              cols="12"
            >
              <b-row>
                <b-col
                  cols="2"
                  align="right"
                >
                  <label for="config-Description">Site Key:</label>
                </b-col>
                <b-col cols="7">
                  <b-form-input
                    id="config-RecaptchaSiteKey"
                    v-model.trim="configuration.recaptchaSiteKey"
                    placeholder="Site Key"
                    size="sm"
                    type="text"
                  />
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col
                  cols="2"
                  align="right"
                >
                  <label for="config-ScoreThreshold">Score Threshold:</label>
                </b-col>
                <b-col cols="3">
                  <b-form-select
                    v-model="configuration.selectedRecaptchaScoreThreshold"
                    :options="recaptchaScores"
                    size="sm"
                  />
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col
                  cols="2"
                  align="right"
                />
                <b-col cols="10">
                  <b-form-checkbox
                    id="data-collection-only-checkbox"
                    v-model="configuration.recaptchaDataCollection"
                    plain
                  >
                    Data collection only
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row
                v-show="configuration.recaptchaDataCollection"
                cols="12"
              >
                <b-col
                  cols="2"
                />
                <b-col cols="10">
                  <span class="warning-message">Score returned by reCAPTCHA will not be evaluated.</span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox
                v-show="!configuration.recaptcha"
                id="recaptcha-disable-checkbox"
                v-model="configuration.disableRecaptcha"
                plain
                class="ml-2 mb-2"
              >
                Disable reCAPTCHA
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="center">
            <h5>Bill Me Later</h5>
            <b-col cols="12">
              <b-form-checkbox
                id="billmelater-checkbox"
                v-model="configuration.billMeLater"
                plain
                class="ml-2"
              >
                Allow Bill Me Later? (credit orders)
              </b-form-checkbox>
            </b-col>
          </b-row>
          <br>
          <b-row align-v="start">
            <h5>Client Code</h5>
          </b-row>
          <b-row>
            <p class="mr-2">
              Used only for backwards compatibility with widgets that do not yet send a Configuration ID.
            </p>
          </b-row>
          <b-row>
            <b-col
              cols="1"
              class="mr-2"
            >
              <label for="clientId">Code:</label>
            </b-col>
            <b-col cols="3">
              <b-form-input
                id="clientId"
                v-model.trim="configuration.clientCode"
                size="sm"
                type="text"
              />
            </b-col>
          </b-row>
          <div>
            <paymentwidget-preview
              :pw-config-number="applicableConfigurationId"
            />
            <!-- ref="previewComponent" -->
          </div>
          <!-- <div class="d-flex justify-content-end mt-2 pt-2"> </div> -->
          <div class="box">
            <div class="success-message mt-2 pt-2">
              <div class="child-div-success-message">
                <b-alert
                  color="success"
                  variant="success"
                  :show="configSavedSuccessfully"
                  class="ml-5 mr-5 pt-2 pb-2"
                >
                  Configuration saved successfully
                </b-alert>
              </div>
            </div>
            <div class="button-action-ct button-align-center mt-2 pt-2">
              <b-button
                variant="primary"
                class="ml-3"
                :disabled="configSavedSuccessfully || $v.configuration.$error"
                @click="saveConfig"
              >
                Save
              </b-button>
              <b-button
                v-b-modal.modal-center
                variant="secondary"
                class="ml-3"
                @click="showPreview"
              >
                Preview
              </b-button>

              <b-button
                variant="secondary"
                class="ml-3"
                @click="resetConfig"
              >
                Cancel
              </b-button>
            </div>
          </div>
        </b-form>
      </b-container>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'
import cards from '../../Data/cardImages'
import ConfigurationCustomId from '../UIComponents/ConfigurationCustomId'
import LoadingSpinner from '../UIComponents/LoadingSpinner'
import PaymentWidgetPreview from '../UIComponents/PaymentWidgetPreview.vue'
import { dataAPI } from '../services/DataAPI.js'
import EditAlternativePaymentItem from '../templates/EditAlternativePaymentItem'

export default {
  components: {
    'paymentwidget-preview': PaymentWidgetPreview,
    'configuration-custom-id': ConfigurationCustomId,
    LoadingSpinner,
    EditAlternativePaymentItem
  },
  mixins: [validationMixin],
  data() {
    return {
      customId: null,
      configuration: {
        addressVerification: false,
        addressVerificationCodes: [],
        recaptcha: false,
        disableRecaptcha: false,
        recaptchaSiteKey: '',
        recaptchaDataCollection: false
      },
      initialConfig: true,
      configurationId: this.$route.params.id,
      clientId: this.$route.params.clientId,
      authCallEnabled: false,
      cards,
      loading: false,
      showAmazonPay: false,
      error: null,
      cardTypes: [
        { text: 'American Express', value: 'american-express' },
        { text: 'Discover', value: 'discover' },
        { text: 'MasterCard', value: 'master-card' },
        { text: 'Visa', value: 'visa' }
      ],
      authTypes: [
        { text: 'Authorization', value: 'AU' },
        { text: 'Verification Only', value: 'VF' },
        { text: 'Authorize and settle', value: 'AS', disabled: true }
      ],
      tokenizeStages: [
        { text: 'Authorization', value: 'AU' },
        { text: 'Billing Agreement', value: 'BA' }
      ],
      paymentServices: [
        { text: 'Central Payments System', value: 'CPS' },
        { text: 'Core', value: 'CORE' }
      ],
      tokenizationForAltPayments: true,
      buttonsSizes: [
        { text: 'Default', value: 'default' },
        { text: 'Medium', value: 'medium' },
        { text: 'Small', value: 'small' }
      ],
      recaptchaScores: [
        { text: '0.0 Most Likely a BOT', value: '0.0' },
        { text: '0.1', value: '0.1' },
        { text: '0.2', value: '0.2' },
        { text: '0.3', value: '0.3' },
        { text: '0.4', value: '0.4' },
        { text: '0.5 Recommended Score', value: '0.5' },
        { text: '0.6', value: '0.6' },
        { text: '0.7', value: '0.7' },
        { text: '0.8', value: '0.8' },
        { text: '0.9', value: '0.9' },
        { text: '1.0 Best Possible Score', value: '1.0' }
      ],
      addressVerificationOptions: [
        { code: '00', label: '5-Digit ZIP and address match' },
        { code: '01', label: '9-Digit ZIP and address match' },
        { code: '02', label: 'Postal code and address match' },
        { code: '10', label: '5-Digit ZIP matches but address does not match' },
        { code: '11', label: '9-Digit ZIP matches but address does not match' },
        { code: '12', label: 'Address matches but ZIP does not match' },
        { code: '13', label: 'Address matches but postal code does not match' },
        { code: '14', label: 'Postal code matches but address not verified' },
        { code: '20', label: 'ZIP and address DO NOT match' },
        { code: '30', label: 'AVS not supported by issuer' },
        { code: '31', label: 'AVS system unavailable' },
        { code: '32', label: 'Address unavailable' },
        { code: '34', label: 'AVS not performed' },
        { code: '40', label: 'Address failed Vantif/Litle checks (applies only to Vantiv/Litle)' },
        { code: '50', label: 'International street address and postal code match' },
        { code: '51', label: 'Account holder name and billing address and postal code match' },
        { code: '52', label: 'Street address and postal code not verified due to incompatible format' },
        { code: '53', label: 'Postal code doe snot match address matches' },
        { code: '54', label: 'No match ZIP/Postal - No Match Plus 4 - No Match Locale' },
        { code: '55', label: 'No match ZIP/Postal - Match Plus 4 - No Match Locale' },
        { code: '56', label: 'Match ZIP/Postal - Match Plus 4 - No Match Locale' },
        { code: '61', label: 'Match ZIP/Postal - No Match Plus 4 - No Match Locale' },
        { code: '62', label: 'Match ZIP/Postal - No Match Plus 4 - Match Locale' },
        { code: '63', label: 'Match ZIP/Postal - Match Plus 4 - Match Locale' },
        { code: '64', label: 'Edit Error - AVS data is invalid' },
        { code: '65', label: 'General error' },
        { code: '67', label: 'Account holder name and billing address and postal code are all incorrect' },
        { code: '68', label: 'Account holder name matches' },
        { code: '69', label: 'Account holder name incorrect but postal code matches' },
        { code: '70', label: 'Account holder name incorrect but address matches' },
        { code: '71', label: 'Account holder name incorrect but address and postal code matches' },
        { code: '72', label: 'Account holder name and postal code match' },
        { code: '73', label: 'Account holder name and address match' },
        { code: '75', label: 'AVS not performed by International issuer' },
        { code: '76', label: 'AVS not performed by Domestic issuer' },
        { code: '77', label: 'No Match ZIP/Postal - No Match Plus 4 - Match Locale' },
        { code: '78', label: 'No Match ZIP/Postal - Match Plus 4 - Match Locale' },
        { code: '79', label: 'Plus 4-Digit ZIP and locale match but 5-Digit ZIP does not match' },
        { code: '80', label: 'Plus 4-Digit ZIP matches but 5-Digit ZIP and locale do not match' },
        { code: '81', label: 'Unrecognized response from association' },
        { code: '33', label: 'Undefined response code' }
      ],
      altPaymentTypes: [
        { text: 'Amazon Pay', value: 'amazon-pay', disabled: false },
        { text: 'Apple Pay', value: 'apple-pay', disabled: false },
        { text: 'PayPal', value: 'pay-pal', disabled: false }
      ],
      navigationItems: [{
        text: 'Home',
        to: { name: 'home' }
      }, {
        text: 'Payments Widget',
        to: { name: 'client' }
      }, {
        text: 'Configurations',
        to: { name: 'configuration' }
      }, {
        text: 'Edit Configuration',
        active: true
      }],
      configSavedSuccessfully: true,
      amazonPayConfigurations: [],
      applePayConfigurations: [],
      payPalConfigurations: [],
      appSource: [
        { text: 'Choose One...', value: '' },
        { text: 'Engage', value: 'engage' },
        { text: 'External', value: 'external' },
        { text: 'Global Care', value: 'globalcare' },
        { text: 'iCare', value: 'icare' },
        { text: 'Magento', value: 'magento' }
      ]
    }
  },
  validations() {
    return {
      configuration: {
        name: {
          required,
          minLength: minLength(3)
        },
        description: {
          required,
          minLength: minLength(3)
        },
        addressVerificationCodes: this.avsCodesRule,
        selectedCardTypes: this.cardSelectionRule,
        selectedTransactionType: this.authTypeSelectionRule,
        selectedTokenizationStage: { required },
        selectedAltPaymentTypes: this.altPaySelectionRule
      }
    }
  },
  computed: {
    shouldPromptForCustomId() {
      return this.configurationId === 'new'
    },
    currentUserToken() {
      return this.$store.state.auth.userToken
    },
    avsCodesRule() {
      return this.isAVSAccepted ? { required } : {}
    },
    cardSelectionRule() {
      return (this.isCreditCardAccepted) ? { required } : {}
    },
    authTypeSelectionRule() {
      return (this.performAuthCal) ? { required } : {}
    },
    altPaySelectionRule() {
      return (this.isAltPaymentsAccepted) ? { required } : {}
    },
    applicableConfigurationId() {
      return this.customId || this.configurationId
    },
    isAVSAccepted() {
      return this.configuration.addressVerification
    },
    isCreditCardAccepted() {
      return this.configuration.credit
    },
    isAltPaymentsAccepted() {
      return this.configuration.altPaymentsAccepted
    },
    performAuthCal() {
      return this.configuration.authCallEnabled
    },
    hasOwnAmazonPayDetails() {
      return this.configuration.amazonPayConfiguration && !this.configuration.amazonPayConfiguration.paymentId
    },
    hasOwnApplePayDetails() {
      return this.configuration.applePayConfiguration && !this.configuration.applePayConfiguration.paymentId
    },
    hasOwnPayPalDetails() {
      return this.configuration.payPalConfiguration && !this.configuration.payPalConfiguration.paymentId
    },
    amazonPayOptions() {
      return this.amazonPayConfigurations
    },
    applePayOptions() {
      return this.applePayConfigurations
    },
    payPalOptions() {
      return this.payPalConfigurations
    },
    hasAmazonPayConfiguration() {
      return this.configuration.amazonPayConfigurationId
    },
    hasApplePayConfiguration() {
      return this.configuration.applePayConfigurationId
    },
    hasPayPalConfiguration() {
      return this.configuration.payPalConfigurationId
    },
    showAmazonPaySelect() {
      return this.amazonPayOptions && this.amazonPayOptions.length > 0
    },
    showApplePaySelect() {
      return this.applePayOptions && this.applePayOptions.length > 0
    },
    showPayPalSelect() {
      return this.payPalOptions && this.payPalOptions.length > 0
    },
    getApplePaymentDetails() {
      return this.configuration.applePayConfiguration
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData',
    configuration: {
      handler: function () {
        this.configSavedSuccessfully = false
      },
      deep: true
    },
    isAltPaymentsAccepted: function () {
      this.configuration.selectedAltPaymentTypes = (!this.isAltPaymentsAccepted) ? [] : this.configuration.selectedAltPaymentTypes
    },
    isAVSAccepted: function () {
      this.configuration.addressVerificationCodes = (!this.isAVSAccepted) ? [] : this.configuration.addressVerificationCodes
    },
    isCreditCardAccepted: function () {
      this.configuration.selectedCardTypes = (!this.isCreditCardAccepted) ? [] : this.configuration.selectedCardTypes
    },
    performAuthCal: function () {
      this.configuration.transactionType = (!this.performAuthCal) ? '' : this.configuration.transactionType
    }
  },
  created() {
    this.fetchData()
    this.fetchAmazonPayOptions()
    this.fetchApplePayOptions()
    this.fetchPayPalOptions()
  },
  methods: {
    customIdProvided(id) {
      this.customId = id
    },
    fetchData() {
      this.error = null
      this.loading = true
      const vm = this
      dataAPI(this.currentUserToken)
        .fetchConfiguration_DataAPI(vm.configurationId)
        .then(function (response) {
          vm.configuration = {
            selectedTokenizationStage: (response && response.tokenizationStage) ? response.tokenizationStage : 'AU',
            selectedPaymentService: (response && response.paymentService) ? response.paymentService : 'CPS',
            selectedButtonsSize: (response && response.buttonsSize) ? response.buttonsSize : 'default',
            selectedRecaptchaScoreThreshold: (response && response.recaptchaScoreThreshold) ? response.recaptchaScoreThreshold : '0.5',
            authCallEnabled: (response.transactionType && response.transactionType !== false),
            selectedCardTypes: response.acceptedCards,
            selectedTransactionType: (response.transactionType && response.transactionType !== false) ? response.transactionType : '',
            addressVerificationCodes: response.addressVerificationCodes ? response.addressVerificationCodes : [],
            ...response,
            selectedAppSource: (response && response.appSource) ? response.appSource : ''
          }
          if (response.amazonPayConfiguration) {
            vm.configuration.amazonPayConfigurationId = response.amazonPayConfiguration.paymentId
          }
          if (response.applePayConfiguration) {
            vm.configuration.applePayConfigurationId = response.applePayConfiguration.paymentId
          }
          if (response.payPalConfiguration) {
            vm.configuration.payPalConfigurationId = response.payPalConfiguration.paymentId
          }
          vm.loading = false
        }).catch(function (response) {
          vm.error = response.toString()
        })
    },
    saveConfig() {
      const vm = this
      vm.loading = true
      vm.$v.configuration.$touch()
      if (vm.$v.configuration.$error) {
        vm.loading = false
        return
      }
      const saveConf = {
        clientId: this.clientId,
        ...this.configuration,
        disableRecaptcha: this.configuration.recaptcha ? false : this.configuration.disableRecaptcha
      }
      const configIdToSave = (this.customId ? 'new:' : '') + this.applicableConfigurationId

      // Call the below method only when all the required configuration fields are selected or enetered
      dataAPI(this.currentUserToken)
        .saveConfiguration_DataAPI(configIdToSave, saveConf)
        .then(function () {
          vm.configSavedSuccessfully = true
          vm.loading = false
          if (vm.configuration.amazonPayConfigurationId &&
            (!vm.configuration.amazonPayConfiguration ||
              vm.configuration.amazonPayConfigurationId !== vm.configuration.amazonPayConfiguration.paymentId)) {
            dataAPI(vm.currentUserToken).copyAlternativePaymentFromPublisher({
              processor: 'AMAZON',
              paymentId: vm.configuration.amazonPayConfigurationId,
              clientId: vm.clientId,
              configurationId: vm.configuration.configurationId
            })
          }
          if (vm.configuration.applePayConfigurationId &&
            (!vm.configuration.applePayConfiguration ||
              vm.configuration.applePayConfigurationId !== vm.configuration.applePayConfiguration.paymentId)) {
            dataAPI(vm.currentUserToken).copyAlternativePaymentFromPublisher({
              processor: 'APPLE',
              paymentId: vm.configuration.applePayConfigurationId,
              clientId: vm.clientId,
              configurationId: vm.configuration.configurationId
            })
          }
          if (vm.configuration.payPalConfigurationId &&
            (!vm.configuration.payPalConfiguration ||
              vm.configuration.payPalConfigurationId !== vm.configuration.payPalConfiguration.paymentId)) {
            dataAPI(vm.currentUserToken).copyAlternativePaymentFromPublisher({
              processor: 'PAYPAL',
              paymentId: vm.configuration.payPalConfigurationId,
              clientId: vm.clientId,
              configurationId: vm.configuration.configurationId
            })
          }
        }).catch(function (error) {
          console.error('Exception occurred while saving configuration: ', error)
        })
    },
    findPaymentsByType(paymentType) {
      return dataAPI(this.currentUserToken)
        .getPaymentsByClientId(this.clientId, paymentType)
        .then(payments => {
          return payments.map(payment => {
            return {
              value: payment.paymentId,
              text: payment.name + ` (${payment.paymentId})`
            }
          })
        })
    },
    editPayment(processor, paymentId) {
      this.$router.push({
        name: 'editAlternativePayment',
        params: {
          clientId: this.clientId,
          paymentId: paymentId,
          paymentType: processor
        }
      })
    },
    fetchAmazonPayOptions() {
      const vm = this
      this.findPaymentsByType('AMAZON')
        .then(amazonPayConfigurations => {
          vm.amazonPayConfigurations = amazonPayConfigurations
        })
    },
    fetchApplePayOptions() {
      const vm = this
      this.findPaymentsByType('APPLE')
        .then(applePayConfigurations => {
          vm.applePayConfigurations = applePayConfigurations
        })
    },
    fetchPayPalOptions() {
      const vm = this
      this.findPaymentsByType('PAYPAL')
        .then(payPalConfigurations => {
          vm.payPalConfigurations = payPalConfigurations
        })
    },
    showPreview() {
      const vm = this
      vm.$store.dispatch('pwpreview/setPWloading', true)
    },
    resetConfig() {
      this.fetchData()
    }
  }
}
</script>

<style scoped>
  .form-check-label > img {
    max-height: 40px;
    max-width: 45px;
  }

  .box {
    display: flex;
    justify-content: space-between;
  }

  .success-message {
    /* display: flex;
    align-content: center;
    justify-content: center */
    flex-grow: 1
  }

  .child-div-success-message {
    justify-content: center;
    align-content: center;
  }

  .button-align-center {
    align-content: center;
  }

  .spinner-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .warning-message {
    font-size: small;
    color: white;
    background-color: blue;
    padding: 5px;
    border-radius: 5px;
    margin: 5px;
    display: inline-block;
  }
</style>
